import {
  useExpanded,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { CaseAdmin, CaseDocumentAdmin } from "pwapi";

import DocumentsColumns from "./DocumentsColumns";
import OrdersTableView from "../ordersTable/OrdersTableView";

type DocumentsTableProps = {
  adminCase?: CaseAdmin;
  documents: CaseDocumentAdmin[];
  columns: any[];
};

const DocumentsTable = ({
  adminCase,
  columns,
  documents = [],
}: DocumentsTableProps) => {
  const { headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: documents,
      autoResetExpanded: false,
      defaultColumn: {
        sortDescFirst: true,
      },
    },
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  return (
    <OrdersTableView
      headerGroups={headerGroups}
      rows={rows}
      prepareRow={prepareRow}
      adminCase={adminCase}
    />
  );
};

export default DocumentsColumns(DocumentsTable, {
  displayCaseInfo: false,
  showPrintLabels: true,
});
